import React from "react";
import {
  Row,
  Col,
  Card,
  Form,
  Input,
  Button,
  Typography,
  Space,
  message,
} from "antd";
import { MailOutlined, PhoneOutlined } from "@ant-design/icons";

const { Title, Text } = Typography;

const ContactSection = ({ onSubmit, loading }) => {
  const [form] = Form.useForm();

  const onFinish = async (values) => {
    try {
      await onSubmit(values);
      form.resetFields(); // Reset form after successful submission
    } catch (error) {
      // Error handling is done in the parent component
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
    message.error("Please fill in all required fields correctly.");
  };

  return (
    <div style={{ padding: "20px 60px" }}>
      <Row
        gutter={[60, 30]}
        align="middle"
        justify="center"
        style={{ maxWidth: 1100, margin: "0 auto" }}
      >
        {/* Left Side */}
        <Col xs={24} md={10}>
          <Title level={3} style={{ fontWeight: 600 }}>
            Contact Us
          </Title>
          <Text style={{ display: "block", color: "#555", fontSize: 15 }}>
            We're here to help at{" "}
            <span style={{ color: "#DDC7BB" }}>NotInTheMarket</span>.<br></br>
            Have a question, suggestion, or inquiry? We'd love to hear from you.
            Simply fill out the form below and our team will connect you with
            the right property expert to assist you.
          </Text>

          <Space direction="vertical" size="middle" style={{ marginTop: 30 }}>
            <Space>
              <MailOutlined style={{ color: "#1677ff", fontSize: 18 }} />
              <Text strong>notinthemarket@gmail.com</Text>
            </Space>
            {/* 
<Space>
  <PhoneOutlined style={{ color: "#1677ff", fontSize: 18 }} />
  <Text strong>
    +92 318 4334402 who we are, listing policies, our story{" "}
  </Text>
</Space> 
*/}
          </Space>
        </Col>

        {/* Right Side (Form Card) */}
        <Col xs={24} md={12}>
          <Card
            style={{
              borderRadius: 10,
              boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
              padding: 20,
              backgroundColor: "#DDC7BB80",
            }}
          >
            <Title level={4} style={{ color: "#1677ff", fontWeight: 600 }}>
              We would love to hear from you! <br /> Get in touch
            </Title>

            <Form
              form={form}
              layout="vertical"
              style={{ marginTop: 20 }}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
            >
              <Row gutter={16}>
                <Col xs={24} sm={12}>
                  <Form.Item
                    name="fullName"
                    label="Full Name"
                    rules={[
                      {
                        required: true,
                        message: "Please enter your full name",
                        whitespace: true,
                      },
                    ]}
                  >
                    <Input placeholder="Full Name" disabled={loading} />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12}>
                  <Form.Item name="company" label="Company (Optional)">
                    <Input
                      placeholder="Company (Optional)"
                      disabled={loading}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col xs={24} sm={12}>
                  <Form.Item
                    name="email"
                    label="Email"
                    rules={[
                      {
                        required: true,
                        message: "Please enter your email",
                      },
                      {
                        type: "email",
                        message: "Please enter a valid email address",
                      },
                    ]}
                  >
                    <Input placeholder="Email" disabled={loading} />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12}>
                  <Form.Item
                    name="phone"
                    label="Phone Number"
                    rules={[
                      {
                        required: true,
                        message: "Please enter your phone number",
                      },
                      {
                        pattern: /^[+]?[\d\s\-()]+$/,
                        message: "Please enter a valid phone number",
                      },
                    ]}
                  >
                    <Input placeholder="Phone Number" disabled={loading} />
                  </Form.Item>
                </Col>
              </Row>

              <Form.Item
                name="message"
                label="Type your Message"
                rules={[
                  {
                    required: true,
                    message: "Please enter your message",
                  },
                  {
                    min: 10,
                    message: "Message should be at least 10 characters long",
                  },
                ]}
              >
                <Input.TextArea
                  rows={4}
                  placeholder="Type your Message"
                  disabled={loading}
                  showCount
                  maxLength={500}
                />
              </Form.Item>

              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                disabled={loading}
                style={{
                  background: "#1677ff",
                  borderRadius: 6,
                  padding: "6px 25px",
                  fontWeight: 500,
                  height: "40px",
                }}
              >
                {loading ? "Sending..." : "Send Message"}
              </Button>
            </Form>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default ContactSection;
